import { c as _c } from "react/compiler-runtime";
import { useCallback, useSyncExternalStore } from 'react';
import { screenPlotHeight, type FIGURE_CHROME } from '../chart-geometry';

/** Every figure on the page asks the same question of the same window. */
const subscribe = (notify: () => void): (() => void) => {
  window.addEventListener('resize', notify);
  return () => window.removeEventListener('resize', notify);
};

/**
 * The height to draw a plot at on this screen.
 *
 * `base` is the height the design gives it — what a laptop shows. A window
 * with room to spare gets a taller plot rather than a band of white under the
 * figure, as long as it is wide enough to keep the figure a figure.
 * Printing is not concerned: the sheet has its own measure, taken once the
 * page is laid out on it (see `usePrintableChart`).
 */
export const useScreenPlotHeight = (base, variant) => {
  const $ = _c(5);
  let t0;
  if ($[0] !== base || $[1] !== variant) {
    t0 = () => screenPlotHeight(base, window.innerHeight, window.innerWidth, variant);
    $[0] = base;
    $[1] = variant;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const onScreen = t0;
  let t1;
  if ($[3] !== base) {
    t1 = () => base;
    $[3] = base;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const onServer = t1;
  return useSyncExternalStore(subscribe, onScreen, onServer);
};